import {
  type DecisionEngineAnalyticsMetricDefinition,
  NormalizationType,
  isDecisionEngineInteractionsMetricDefinition,
} from "src/types/visual";

export { getAggregationConfiguration } from "@hightouch/lib/query/visual/util";
export { mapAggregationConfigurationToConfigurationOption } from "@hightouch/lib/query/visual/util";

export const mapNormalizationConfigurationToDescriptionLabel = (
  metricDefinition: DecisionEngineAnalyticsMetricDefinition,
): string | null => {
  if (isDecisionEngineInteractionsMetricDefinition(metricDefinition)) {
    return null;
  }

  const normalization = metricDefinition.config.normalization;
  return mapNormalizationLabel(normalization);
};

export const mapNormalizationLabel = (
  normalization: NormalizationType | undefined,
): string => {
  switch (normalization) {
    case NormalizationType.LiftPercent:
      return "% lift";
    case NormalizationType.AbsoluteLift:
      return "Absolute lift";
    case NormalizationType.RatePerUser:
      return "Per-member rate";
    case NormalizationType.RatePerInteraction:
      return "Per-interaction rate";
    case NormalizationType.TreatmentSize:
      return "Normalized to treatment size";
    case NormalizationType.HundredPercent:
      return "Normalized to entire population size";
    case NormalizationType.None:
    default:
      return "";
  }
};
